import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading, initialized } = useAuth();
  const location = useLocation();

  // Skip render redirect while we're still checking
  if (!initialized || loading) {
    return (
      <div
        data-testid="protected-loading"
        className="min-h-screen flex items-center justify-center"
        style={{ background: "#FAF6EC" }}
      >
        <div className="flex items-center gap-3" style={{ color: "#1B4332" }}>
          <Loader2 className="animate-spin" size={18} />
          <span className="text-sm">Checking your session&hellip;</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
